const access = ({ meta: { access } }) => access || "";

export const isPublic = ({ matched }) =>
  matched.some((data) => access(data).includes("public"));

export const isOnlyPublic = ({ matched }) =>
  matched.some((data) => access(data) === "public-only");
